module.exports = __webpack_public_path__ + "img/1450632168.3534583d.jpg";